import { cn } from '@/shared/ui/cn'
import { DatePicker } from './date-picker'

type BirthdatePickerProps = {
  id: string
  label?: string
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  error?: string
  required?: boolean
  disabled?: boolean
  className?: string
}

function getTodayLocalIsoDate() {
  const now = new Date()
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function BirthdatePicker({
  id,
  label,
  value,
  onChange,
  onBlur,
  error,
  required,
  disabled,
  className,
}: BirthdatePickerProps) {
  const today = getTodayLocalIsoDate()
  const earliest = `${Number(today.slice(0, 4)) - 120}-01-01`
  return (
    <DatePicker
      id={id}
      label={label}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      captionLayout="dropdown"
      startMonth={earliest}
      endMonth={today}
      maxDate={today}
      error={error}
      required={required}
      disabled={disabled}
      className={cn(className)}
    />
  )
}

export { BirthdatePicker }
export type { BirthdatePickerProps }
